import { render, staticRenderFns } from "./ChangelogView.vue?vue&type=template&id=20d68139&"
import script from "./ChangelogView.vue?vue&type=script&lang=ts&"
export * from "./ChangelogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports